module.exports = __webpack_public_path__ + "img/close.fa42cfe2.svg";